import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

// Désactivation temporaire de StrictMode pour éviter les problèmes avec Leaflet
// En production, StrictMode n'est pas actif donc pas de problème
if (process.env.NODE_ENV === 'development') {
  root.render(<App />);
} else {
  root.render(
    <React.StrictMode>
      <App />
    </React.StrictMode>
  );
}

reportWebVitals();
